'use strict';
const angular = require('angular');

export class HierarchyComponent {
    
    Util: any;
    $document:any;
    $uibModal:any;
    selectedView: any;
    store:any;
    filter:any;
    scope:any;
    arrayHierarchy:any;
    ngNotification:any;
    

    constructor(localStorage,$scope, $http, $filter, Notification, $uibModal, $document, Util, $window, $rootScope) {
       
        let self = this;
        this.Util = Util;
        this.scope =$scope;
        this.$document = $document;
        this.$uibModal = $uibModal;
        this.store = localStorage;
        this.filter=$filter;
        this.selectedView = this.store.get('selectedView');
        this.arrayHierarchy = ['dropdown','radio','checkbox','multidropdown'];
        this.ngNotification = Notification;
    }

   
    createRelation(){
        let self = this;
    
        let relationModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'Relation.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$hierarchyModal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {

                this.oneAtATime        = true;
                this.allElement        = {};
                this.totalRelation     = {};
                this.isTotalRelationLengthExceedOne = false;
                this.arrayHierarchy    = self.arrayHierarchy;
                this.isObject          = angular.isObject;
               
                let hierarchyObj    = {
                    selectedParent  :'',
                    selectedChild   :'',
                    parentAttribute :{},
                    childAttribute  :{},
                    parentList      :[],
                    childList       :[],
                    relationArray   :[],
                    objDataBind     :{}
                   
                }

                var init = function(_this){
                    
                    
                    for (var index = 0,allAttr=self.Util.getIteams(self.selectedView.view.controls.A); index < allAttr.length; index++) {
                        var element = allAttr[index];
                        if(_this.arrayHierarchy.indexOf(element.label) > -1 ){
                           _this.allElement[element.properties.Basic["Field Name"].selectedValue || element.label] = element;
                        } 
                    }
                    for (var key in  _this.allElement) {
                        onLoadRelation(_this.allElement[key],key);   
                    }

                    if(Object.keys(_this.totalRelation).length == 0){
                        _this.totalRelation['pRow_'+(Object.keys(_this.totalRelation).length + 1)] = angular.copy(hierarchyObj);
                    }
                }
                
                this.changeParentDropdown = function(obj){
                    obj.parentAttribute = this.allElement[obj.selectedParent];
                    obj.parentList      =  obj.parentAttribute.properties['Data Source'].table.list;
                    currentContext.changeChildDropdown(obj);
                }

                this.changeChildDropdown  = function(obj){
                    obj.childAttribute = this.allElement[obj.selectedChild];
                    if(obj.childAttribute && validateRelation(this.totalRelation)){
                        obj.childList     = obj.childAttribute.properties['Data Source'].table.list;
                        createDatabindJson(obj);
                    }
                }

                const isTotalRelationLengthGreaterThanOne = function(obj) {
                    const objLength = Object.keys(obj);
                    return objLength.length && objLength.length > 1;
                }
                
                var createDatabindJson =  function(obj){
                    var relationArray    = [];
                    obj.objDataBind = {};
                    var count = 0;
                    
                    for (var index = 0; index <  obj.parentList.length; index++) {
                        var element =  obj.parentList[index].relation;
                        if(element[obj.selectedChild]){
                           obj.objDataBind[obj.selectedParent+count]  =  obj.parentList[index];
                           obj.objDataBind[obj.selectedChild+count]   =  element[obj.selectedChild];
                           relationArray.push('row_'+count);
                           count++;
                        }
                    }
                    if(relationArray.length == 0 ){
                        relationArray = ['row_0'];
                    }
                    obj.relationArray =  relationArray;
                }
                
                var onLoadRelation = function(paramObj,parent) {
                    var relationList = paramObj.properties['Data Source'].table.list,
                        childList = [],
                        hierarchyJson;
                    
                    for (var index = 0; index < relationList.length; index++) {
                        for(var key in relationList[index].relation){
                            if(key && childList.indexOf(key) < 0){
                                childList.push(key);
                                hierarchyJson = angular.copy(hierarchyObj);
                                hierarchyJson.selectedParent = parent;
                                hierarchyJson.selectedChild  = key;
                                currentContext.changeParentDropdown(hierarchyJson);
                                currentContext.totalRelation['pRow_'+(Object.keys(currentContext.totalRelation).length + 1)] = hierarchyJson;
                            }
                        }
                    }

                    currentContext.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(currentContext.totalRelation);
                };

                this.addParentRow = function(e,index){
                    e.preventDefault();
                    e.stopPropagation();
                    this.totalRelation['pRow_'+(parseInt(index) + 1)] = angular.copy(hierarchyObj);
                    this.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(this.totalRelation);
                };
                
                this.removeParentRow =function(e,index){
                    e.preventDefault();
                    e.stopPropagation();

                    var parentList  = this.totalRelation[index].parentList;
                    for (var i = 0; i <  parentList.length; i++) {
                        parentList[i].relation = {};
                    }
                    delete this.totalRelation[index];
                    this.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(this.totalRelation);
                };

                this.filterParentList = function(objParam) {
                    var parentObj = [];
                    for (var index = 0; index <  objParam.parentList.length; index++) {
                        var element =  objParam.parentList[index];
                        if(element != objParam.objDataBind[objParam.selectedParent+index] ){
                           parentObj.push(element);
                        }
                    }
                    return parentObj;
                };

               
                
                this.addIntoList = function(index,objParam) {
                    for (var i = 0; i <  objParam.parentList.length; i++) {
                        if(objParam.relationArray.indexOf('row_'+i) < 0){
                            objParam.relationArray.push('row_'+i);
                            break;
                        }   
                    }
                };

                this.removeFromList=function(index,objParam) {
                    for (var i = 0; i < objParam.relationArray.length; i++) {
                        if(objParam.relationArray[i] == 'row_'+index){
                            objParam.relationArray.splice(i, 1);
                            delete objParam.objDataBind[objParam.selectedParent+index];
                            delete objParam.objDataBind[objParam.selectedChild+index];
                        }
                    }
                };
                
                this.cancel = function () {
                    relationModal.close(false);
                };
                
                var validateRelation = function(paramObj){
                    for (var key in paramObj) {
                        for (var key1 in paramObj) {
                            if(key1 != key){
                                if(paramObj[key].selectedChild ==paramObj[key1].selectedChild && paramObj[key].selectedParent ==  paramObj[key1].selectedParent){
                                    self.ngNotification.error({
                                        message: "Same Relation Already Defined", positionX: 'center', replaceMessage: true
                                    });
                                    return false;
                                    
                                }
                                if(paramObj[key].selectedChild == paramObj[key1].selectedParent && paramObj[key].selectedParent ==  paramObj[key1].selectedChild){
                                    self.ngNotification.error({
                                        message: "Child is not become parent", positionX: 'center', replaceMessage: true
                                    });
                                    return false;
                                    
                                }
                            }
                        }    
                    }
                    return true;
                };
                
                this.submitHierarchyData = function(){
                    
                    for (var key in this.totalRelation) {
                        var objList = this.totalRelation[key];
                        if (objList.selectedParent && objList.selectedChild) {
                            var parentAttrList = this.allElement[objList.selectedParent].properties['Data Source'].table.list;
                            for (var index = 0; index < parentAttrList.length; index++) {
                                delete parentAttrList[index].relation[objList.selectedChild];
                            }
                            for (var index = 0; index < objList.relationArray.length; index++) {
                                if (objList.objDataBind[objList.selectedChild + index] != undefined) {
                                    if (objList.objDataBind[objList.selectedParent + index]) {
                                        if (objList.objDataBind[objList.selectedChild + index].length > 0) {
                                            objList.objDataBind[objList.selectedParent + index].relation[objList.selectedChild] = objList.objDataBind[objList.selectedChild + index];
                                        } else {
                                            self.ngNotification.error({ message: 'No Value(s) selected for Child Attribute(s)', positionX: 'center', replaceMessage: true });
                                            return;
                                        }
                                    }
                                }
                                else {
                                    self.ngNotification.error({ message: 'No Value(s) selected for Child Attribute(s)', positionX: 'center', replaceMessage: true });
                                    return;
                                }
                            }
                        }
                    }
                    this.cancel();
                }
                let currentContext     = this;

                init(currentContext);
            }

        });
    }
}

export default angular.module('directives.hierarchy', [])
.component('hierarchy', {
    template: require('./hierarchy.html'),
    controller: HierarchyComponent,
    controllerAs: 'attrCtrl'
    
}).name;



// WEBPACK FOOTER //
// ./client/components/hierarchy/hierarchy.component.ts